import { animate, state, style, transition, trigger } from '@angular/animations';


export const rotateIcon = trigger('rotateIt', [
  state('open', style({
    transform: 'rotate(90deg)'
  })),
  state('closed', style({
    transform: 'rotate(0deg)'
  })),
  transition('open => closed', [
    animate('0.3s')
  ]),
  transition('closed => open', [
    animate('0.3s')
  ]),
]);
